<template lang="html">
    <div class="row bloc-global-dates">
        <div class="col bloc-global-date d-flex flex-column">
            <span :class="isActiveDate(period.openingDate) ? 'active' : ''"> {{ getDate(period.openingDate, "DD/MM") }} </span>
            <span>{{ $t("catalogForecast.periodOpening") }}</span>
        </div>
        <div class="col bloc-global-date d-flex flex-column align-items-center">
            <span :class="isActiveDate(period.firmorderClosingDate) ? 'active' : ''">
                {{ getDate(period.firmorderClosingDate, "DD/MM") }}
            </span>
            <span>{{ $t("catalogForecast.firmOrderClosing") }}</span>
        </div>
        <div class="col bloc-global-date d-flex flex-column align-items-end">
            <span :class="isActiveDate(period.forecastClosingDate) ? 'active' : ''"> {{ getDate(period.forecastClosingDate, "DD/MM") }} </span>
            <span>{{ $t("catalogForecast.forecastExported") }}</span>
        </div>
    </div>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextareaInputBloc from "@/components/ui/Form/DefaultTextareaInputBloc";
import {moment} from "@/utils/moment";

export default {
    components: {DefaultTextareaInputBloc, ModalDefault},
    props: {
        period: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
        }
    },
    created() {
    },
    methods: {
        getDate(date, format, start = 'second') {
            return moment(date).startOf(start).format(format).toUpperCase(); // Nouveau formattage pur éviter le décallage horaire
        },
        isActiveDate(date) {
            return moment().format("YYYYMMDD") >= moment(date).format("YYYYMMDD");
        },
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
.bloc-global-dates {
    .bloc-global-date {
        position: relative;
        z-index: 0;
        &:after {
            content: "";
            background-color: #747795;
            position: absolute;
            width: 100%;
            height: 6px;
            top: 42px;
            z-index: 0;
        }
        span:first-child {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 90px;
            width: 90px;
            border-radius: 100%;
            border: 1px solid #747795;
            color: #747795;
            background-color: #fff;
            font-size: 18px;
            z-index: 1;
            &.active {
                color: #fff;
                background-color: #747795;
            }
        }
        span:nth-child(2) {
            width: 90px;
            font-size: 16px;
            margin-top: 15px;
            text-transform: initial;
            text-align: center;
        }
    }
    span {
        color: #707070;
    }
}
</style>



// WEBPACK FOOTER //
// PeriodDates.vue?42224dce